import {
  SHStack,
  SHStackProps,
  SHTypography,
} from "@components/design-systems";
import { RollbackCircleSVG } from "@components/svgs/rollback-circle";
import { useTheme } from "@mui/material";

type MSTableResetButtonProps = SHStackProps & {
  label?: string;
  disabled?: boolean;
  width?: string;
  height?: string;
  fontSize?: string;
  onClick: () => void;
};

export const MSTableResetButton = ({
  label = "Reset",
  disabled = false,
  width = "fit-content",
  height = "40px",
  fontSize = "13px",
  onClick,
  ...others
}: MSTableResetButtonProps) => {
  const { palette, shadows } = useTheme();

  const handleClick = () => {
    !disabled && onClick();
  };

  return (
    <SHStack
      padding={"4px 15px"}
      border={`1px solid ${
        disabled ? palette.text.disabled : palette.error[100]
      }`}
      borderRadius={"80px"}
      marginTop={"0px !important"}
      bgcolor={disabled ? "#BDBDBD" : palette.error[50]}
      direction={"row"}
      width={width}
      height={height}
      alignItems={"center"}
      gap={1.5}
      onClick={handleClick}
      boxShadow={disabled ? "none" : shadows[1]}
      sx={{
        pointerEvents: disabled ? "none" : "auto",
        transition: "box-shadow 0.3s ease, transform 0.3s ease",
        userSelect: "none",
        cursor: "pointer",
        "&:hover": {
          boxShadow: "none",
          transition: "all 0.3s ease",
        },
        "&:active": {
          boxShadow: `inset 3px 3px 4px ${palette.warning.main}`,
        },
      }}
      {...others}
    >
      <SHTypography
        variant={"subtitle1"}
        fontSize={fontSize}
        color={disabled ? palette.common.white : palette.error.main}
      >
        {label}
      </SHTypography>

      <SHStack
        borderRadius={"50%"}
        alignItems={"center"}
        justifyContent={"center"}
        width={20}
        height={20}
        sx={{
          boxShadow: shadows[1],
        }}
      >
        <RollbackCircleSVG
          color={disabled ? palette.common.white : palette.error.main}
        />
      </SHStack>
    </SHStack>
  );
};
